import React, { useEffect, useRef } from 'react';
import { isChildVisible } from './util';

const WithChildrenVisibilityDetector = ({
    children,
    onLoad,
    ...props
}: React.PropsWithChildren<any> & { onLoad: (total: number, hidden: number) => void }) => {
    const containerRef = useRef(null); // Ref for the parent container

    useEffect(() => {
        const checkAndReportVisibility = () => {
            if (!containerRef.current) {
                return;
            }

            const parent = containerRef.current as HTMLElement;

            const visibleChildren = Array.from(parent.children).filter((child) =>
                isChildVisible(parent, child as HTMLElement)
            );
            const hiddenCount = parent.children.length - visibleChildren.length;

            // Call onLoad with the total number of children and the number of hidden children
            if (onLoad) {
                onLoad(parent.children.length, hiddenCount);
            }
        };

        checkAndReportVisibility();
    }, []); // Only run once

    return (
        <div ref={containerRef} {...props}>
            {children}
        </div>
    );
};

export default WithChildrenVisibilityDetector;

// Usage example
/*
function App() {
  const handleLoad = (total, hidden) => {
    console.log(`Total children: ${total}, Hidden children: ${hidden}`);
  };

  return (
    <WithChildrenVisibilityDetector onLoad={handleLoad} style={{height: '100px', overflowY: 'scroll'}}>
      <div>Child 1 (Visible)</div>
      <div>Child 2 (Visible)</div>
      <div style={{marginTop: '200px'}}>Child 3 (Potentially Hidden)</div>
    </WithChildrenVisibilityDetector>
  );
}
*/
